import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportChargeRequest {
  id?: string;

  @observable
  licensePlate?: string;

  @observable
  countryId?: string;

  /**
   * Email.
   * @example
   * test@example.com
   */
  @observable
  email?: string;
}

export class SubLedgerReportChargeRequestX extends SubLedgerReportChargeRequest {
  @observable id?: string;
}

export const SubLedgerReportChargeRequestValidationRules: EntityValidationRules<SubLedgerReportChargeRequest> = {
  email: {
    isEmail: { required: false },
  },
  id: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
    isLength: {
      min: 1,
      optional: true,
    },
  },
};
